<script>
import { ArticleTag } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit ArticleTag',
      addRoute: { name: 'Add ArticleTag' },
      verboseName: 'Tag artykułu',
      verboseNamePlural: 'Tagi artykułów',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'name', label: 'nazwa' }
      ]
    }
  },
  computed: {
    service() {
      return ArticleTag
    }
  }
}
</script>
